import { createFileRoute, Outlet, Link } from '@tanstack/react-router'
import { useSession } from '@/shell/session'
import { NotFoundState } from '@/components/states'
import { Button } from '@/components/ui/button'
import { Page } from '@/components/page'

/** Workspace-scoped screens. An unknown or inaccessible workspace is "not found", never "denied". */
export const Route = createFileRoute('/_app/w/$ws')({
  component: WorkspaceLayout,
})

function WorkspaceLayout() {
  const { ws } = Route.useParams()
  const s = useSession()
  if (!s.workspaces.some(w => w.id === ws)) {
    return (
      <Page>
        <NotFoundState
          what="This workspace"
          action={
            <Button asChild variant="primary" size="sm">
              <Link to="/">Go to your workspaces</Link>
            </Button>
          }
        />
      </Page>
    )
  }
  return <Outlet />
}
